export default {
  setTicketBooks (state, ticketBooks) {
    state.ticketBooks = ticketBooks
  },
  setLoading (state, loading) {
    state.ticketBooksLoading = loading
  }
}
